import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'
import {isEditor} from '../../../../../../../commons/selectors/environment'
import {useWidgetActions, useWidgetState} from '../../../../hooks/state-provider'
import {getSelectedDate, getSelectedEventId} from '../../../../selectors/calendar-layout'
import {getCompId} from '../../../../selectors/component'
import {EventDetails} from './event-details'
import {EventList} from './event-list'
import {CalendarPopupProps} from './interfaces'
import s from './popup.scss'

export const CalendarPopup = ({className}: CalendarPopupProps) => {
  const popupRef = useRef<HTMLDivElement>(null)

  const {closeMonthlyCalendarPopup} = useWidgetActions()
  const selectedDate = useWidgetState(getSelectedDate)
  const selectedEventId = useWidgetState(getSelectedEventId)
  const componentId = useWidgetState(getCompId)
  const editor = useWidgetState(isEditor)

  const closePopupOnEscape = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      closeMonthlyCalendarPopup()
      focusElement({
        selector: hookToAttributeSelector(DH.calendarCell(selectedDate), {componentId}),
        canFocus: true,
        preventScroll: true,
      })
    }
  }

  useEffect(() => {
    const closePopup = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        closeMonthlyCalendarPopup()
      }
    }

    if (selectedDate) {
      document.addEventListener('mousedown', closePopup)
    }

    return () => {
      document.removeEventListener('mousedown', closePopup)
    }
  }, [selectedDate])

  useEffect(() => {
    setTimeout(() =>
      focusElement({
        selector: hookToAttributeSelector(DH.calendarPopupCloseButton, {componentId}),
        canFocus: true,
        preventScroll: editor,
      }),
    )
  }, [])

  return (
    <div ref={popupRef} className={className}>
      <div className={classNames(s.popupContent, {[s.eventList]: !selectedEventId})} onKeyUp={closePopupOnEscape}>
        {selectedEventId ? <EventDetails /> : <EventList />}
      </div>
    </div>
  )
}
